<!--- Template not in use--->
<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-4">
                <!-- qickstarts -->
                <div class="col" v-if="quickstart">
                    <card header-classes="bg-transparent">
                        <div slot="header" class="row align-items-center">
                            <div class="col-10">
                                <h5 class="h3 mb-1">Quickstart</h5>
                                <h6 class="text-uppercase text-muted ls-1 mb-0">Folgende Assistenten helfen Ihnen bei der schnellen Einrichtung von Socialguard.</h6>
                            </div>
                            <div class="col-2 text-right">
                                <base-dropdown class="dropdown"
                                               position="right">
                                    <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-ellipsis-v"></i>
                                    </a>
                                    <template>
                                        <a href="#" @click.prevent="quickstart = false" class="dropdown-item">Quickstart verbergen</a>
                                    </template>
                                </base-dropdown>
                            </div>
                        </div>
                        <!--- Assistenten mit Icon -->
                        <div class="row">
                            <div class="col">
                                <!---<font-awesome-icon :icon="['far','fa-id-badge']"></font-awesome-icon> --->
                                <router-link to="/oasiscerts/create"><h5>Oasis Zertifikat hochladen</h5></router-link>
                            </div>
                            <div class="col">
                                <!---<font-awesome-icon :icon="['far','fa-id-badge']"></font-awesome-icon> --->
                                <router-link to="/oasiscerts/dashboard"><h5>Oasis Betriebsstätten konfigurieren</h5></router-link>
                            </div>
                            <div class="col">
                                <!---<font-awesome-icon :icon="['fas','fa-user']"></font-awesome-icon> ---->
                                <router-link to="/users/create"><h5>Zugangsdaten anlegen</h5></router-link>
                            </div>
                            <div class="col">
                                <router-link to="/users/profiles_create"><h5>Mitarbeiter-Profile anlegen</h5></router-link>
                            </div>
                        </div>

                    </card>

                </div>
                <div v-else class="col text-right">
                    <a href="#" @click.prevent="quickstart = true"><badge type="light">Quickstart anzeigen</badge></a>
                </div>
            </div>
          <!---- Filter area ---->
          <div class="row">
            <div class="col-2">
              <base-input input-classes="btn">
                <select class="form-control" v-model="range">
                  <option v-for="(item,i) in dateRanges"  :key="i+'dr'" :value="item.value">{{ item.name }}</option>
                </select>
              </base-input>
            </div>
            <div class="col-3">
              <base-input
                  class="col-form-label p-0"
                  placeholder="von"
              >
                <flat-pickr :config="config"
                            class="form-control form-control-alternative datepicker"
                            v-model="range">
                </flat-pickr>
              </base-input>
            </div>
            <div class="col-4">
              <!--- select location --->
              <base-dropdown >
                <template v-slot:title>
                  <base-button type="secondary" class="dropdown-toggle nav-link py-2 px-3">
                    {{ (location.id===0 ? 'alle Standorte' : location.name)}}
                  </base-button>
                </template>
                <a class="dropdown-item" @click="location= {id:0}">Alle Standorte</a>
                <a v-for="loc in $store.getters['location/showLocationCollection']" class="dropdown-item" :key="'locb'+loc.id" @click="location=loc">{{loc.name}}</a>
              </base-dropdown>
              <!--- end select --->
            </div>
          </div>
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-6">
                  <stats-card-customizable :figure="0" :customer="customer" :location="location" :from="from" :to="to"/>
                </div>
                <div class="col-xl-3 col-lg-6">
                  <stats-card-customizable :figure="5" :customer="customer" :location="location" :from="from" :to="to"/>
                </div>
                <div class="col-xl-3 col-lg-6">
                  <stats-card-customizable :figure="2" :customer="customer" :location="location" :from="from" :to="to"/>

                </div>
                <div class="col-xl-3 col-lg-6">
                  <stats-card-customizable :figure="3" :customer="customer" :location="location" :from="from" :to="to"/>
                </div>
            </div>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-8 mb-5 mb-xl-0">
                  <VisitorChart :customer="customer" :location="location" :from="from" :to="to" />
                </div>

                <div class="col-xl-4">
                  <TopFlopChart :customer="customer" :from="from" :to="to" />
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-xl-8 mb-5 mb-xl-0">
                </div>
                <div class="col-xl-4">
                    <!---<social-traffic-table></social-traffic-table>--->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  // Charts
  import "flatpickr/dist/flatpickr.css";
  import {German} from "flatpickr/dist/l10n/de.js";
  import FlatPickr from "vue-flatpickr-component/src/component";
  import moment from 'moment';
  import StatsCardCustomizable from "@/components/StatsCardCustomizable.vue";
  import VisitorChart from "@/components/Charts/VisitorChart.vue";
  import TopFlopChart from "@/components/Charts/TopFlopChart.vue";

  moment.locale('de');

  // Tables
  // import SocialTrafficTable from './ServiceDashboard/SocialTrafficTable';
  // import PageVisitsTable from './ServiceDashboard/PageVisitsTable';

  export default {
    components: {
      TopFlopChart,
      VisitorChart,
      StatsCardCustomizable,
      FlatPickr
    },
    data() {
      return {
          quickstart: true,
          customer: { id: 0 },
          location: { id: 0 },
          modals: {
              oasis: false
          },
        config: {
          altFormat: 'd.m.Y H:i',
          dateFormat: 'Z',
          mode: 'range',
          enableTime: true,
          maxDate: new Date(),
          altInput: true,
          allowInput: true,
          locale: German
        },
        dateRanges: [
          { id: 0, value: new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate(),0).toISOString() + ' bis ' + new Date().toISOString(), name:'heute'},
          { id: 1, value: new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate()-1,0).toISOString() + ' bis ' + new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate(),0).toISOString(), name:'gestern'},
          { id: 2, value: new Date(new Date().getFullYear(),new Date().getMonth(),1).toISOString() + ' bis ' + new Date().toISOString(), name:'aktueller Monat'},
          { id: 3, value: new Date(new Date().getFullYear(),new Date().getMonth()-1,1).toISOString() + ' bis ' + new Date(new Date().getFullYear(),new Date().getMonth(),1).toISOString(), name:'letzter Monat'}
        ],
        range: new Date(new Date().getFullYear(),new Date().getMonth(),1).toISOString() + ' bis ' + new Date().toISOString(),
        from: new Date(new Date().getFullYear(),new Date().getMonth(),1).toISOString(),
        to: new Date().toISOString(),
        timer: null,
        tick: 1
      };
      },
      created() {
          if(!this.$store.getters['location/isReady']) {
              this.$store.dispatch('location/getLocationCollection');
          }
          this.location.id = this.$store.getters('authentication/customer');
        // update daterange; CAUSES EVERY KPI TO REFRESH BY NATURE
        this.timer = setInterval(() => {
          let current = this.dateRanges.find(obj => obj.value === this.range ).id
          this.dateRanges =[
            { id: 0, value: new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate(),0).toISOString() + ' bis ' + new Date().toISOString(), name:'heute'},
            { id: 1, value: new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate()-1,0).toISOString() + ' bis ' + new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate(),0).toISOString(), name:'gestern'},
            { id: 2, value: new Date(new Date().getFullYear(),new Date().getMonth(),1).toISOString() + ' bis ' + new Date().toISOString(), name:'aktueller Monat'},
            { id: 3, value: new Date(new Date().getFullYear(),new Date().getMonth()-1,1).toISOString() + ' bis ' + new Date(new Date().getFullYear(),new Date().getMonth(),1).toISOString(), name:'letzter Monat'}
          ];
          this.$set(this.config,'maxDate', new Date())
          this.range = this.dateRanges[current].value;
        },100000)
      },
    beforeDestroy() {
      clearInterval(this.timer)
    },
      watch:{
        range: function () {
          if (this.range.includes('bis')) {
            let r = this.range.split(' bis ')
            this.from = r[0]
            this.to = r[1]
            this.tick++
          }
        }
      },
      computed: {
          thisMonth() {
              return moment(new Date()).format('MMMM');
          },
          lastMonth() {
              var d = new Date();
              var year = d.getFullYear();
              var month = d.getMonth();
              var day = d.getDate();
              var c = new Date(year, month - 1, day);
              return moment(c).format('MMMM');
          }
      },
  };
</script>
<style></style>
